import {
  JsonInputProps as MantineJsonInputProps,
  JsonInput as MantineJsonInput,
} from '@mantine/core';

export type JsonInputProps = MantineJsonInputProps;

export const JsonInput = MantineJsonInput;

JsonInput.displayName = 'JsonInput';
